import type { PersonRow } from './panoramaPeopleRows';

export function isOutUntil(row: PersonRow, untilIso: string): boolean {
	if (!row.nextOutDate) return false;
	return row.nextOutDate <= untilIso;
}

export interface PendingSummary {
	byStage: Record<'manager' | 'client' | 'dp' | 'correction', number>;
	total: number;
	oldestDays: number | null;
}

export function summarizePending(rows: PersonRow[], referenceDate: Date): PendingSummary {
	const pendingRows = rows.filter(r => r.status === 'pending' || r.status === 'approval-urgent');

	const byStage: Record<'manager' | 'client' | 'dp' | 'correction', number> = {
		manager: 0,
		client: 0,
		dp: 0,
		correction: 0,
	};

	let oldestTime: number | null = null;

	pendingRows.forEach(row => {
		row.requestStages.forEach(stage => {
			byStage[stage]++;
		});

		if (row.requestSince) {
			const stageTime = new Date(row.requestSince).getTime();
			if (!Number.isNaN(stageTime) && (oldestTime === null || stageTime < oldestTime)) {
				oldestTime = stageTime;
			}
		}
	});

	const oldestDays =
		oldestTime !== null
			? Math.max(0, Math.floor((referenceDate.getTime() - oldestTime) / (1000 * 60 * 60 * 24)))
			: null;

	return {
		byStage,
		total: pendingRows.length,
		oldestDays,
	};
}
